import useGetBanks from 'hooks/Bank/useGetBanks';

import _groupBy from 'lodash/groupBy';

const useBanksList = () => {
  const banksListQuery = useGetBanks();

  const banks = banksListQuery.data || [];

  const banksGrouped = _groupBy(banks, 'groupDisplayName');

  const mostCommonBanks = Object.entries(banksGrouped).filter(([, banks]) =>
    banks.find((bank) => bank.popular),
  );

  const allOtherBanks = Object.entries(banksGrouped).filter(([, banks]) =>
    banks.every((bank) => !bank.popular),
  );

  return {
    banksGrouped,
    mostCommonBanks,
    allOtherBanks,
    banksListQuery,
  };
};

export default useBanksList;
